<template>
  <v-data-table
    :headers="headers"
    :items="securities"
    :rows-per-page-items="rowsPerPageItems"
    :pagination.sync="pagination"
    class="elevation-1"
    @update:pagination="updatePagination"
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr>
        <td
          v-for="(header, index) in headers"
          :key="index"
          class="text-xs"
        >
          <div v-if="header.value === 'XXX-SALDO'">
            {{ props.item[header.value] | currency('€') }}
          </div>

          <div v-else>
            {{ props.item[header.value] }}
          </div>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { setQuery } from '@/helpers';

export default {
  name: 'RKKTransactionsComponent',
  props: {
    securities: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        totalItems: this.securities.length,
      },
      rowsPerPageItems: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: 'All', value: -1 },
      ],
      headers: [
        {
          text: 'XXX-BUDAT',
          value: 'XXX-BUDAT',
        },
        {
          text: 'XXX-UMART',
          value: 'XXX-UMART',
        },
        {
          text: 'XXX-TEXT1',
          value: 'XXX-TEXT1',
        },
        {
          text: 'XXX-TEXT2',
          value: 'XXX-TEXT2',
        },
        {
          text: 'XXX-TEXT3',
          value: 'XXX-TEXT3',
        },
        {
          text: 'XXX-SALDO',
          value: 'XXX-SALDO',
        },
      ],
      isLoadTableData: false,
    };
  },
  watch: {
    pagination: {
      handler() {
        this.isLoadTableData = true;
      },
    },
  },
  async mounted() {
    await this.$nextTick();
    this.changePage();
  },
  methods: {
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery({ rkkPage: pagination.page }, this.$route, this.$router);
      }
    },
    changePage() {
      const { rkkPage } = this.$route.query;
      this.pagination.page = rkkPage ? Number(rkkPage) : 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/baader/RKKTransactionsComponent.vue